<template>
  <div>
    <v-card class="white" style="width: 180px">
      <div class="d-flex">
        <profileImage
          v-show="image ? ':src' : ':username'"
          :src="image"
          inline
          :size="180"
          :userInfoCard="true"
          :username="name ? name : email"
          :userProfile="true"
        ></profileImage>
      </div>
      <v-card-text class="px-2">
        <div class="d-flex justify-start word-break">
          <span
            style="font-size: 18px; color: black; max-width: 200px"
            class="text-truncate text-capitalize mb-2"
          >
            <b>{{ name ? name : email }}</b></span
          >
        </div>
        <span class="d-flex justify-start word-break display-style pt-1">
          <v-icon small color="#2a206a">mdi-email-outline</v-icon>
          <b class="pl-2"> {{ email }} </b>
        </span>
        <span
          class="d-flex justify-start word-break display-style text-capitalize pt-1 pb-0"
        >
          <v-icon small color="#2a206a">mdi-account-tie</v-icon>
          <b class="pl-2"> {{ role }} </b>
        </span>
        <span
          class="d-flex justify-start word-break display-style text-capitalize pt-1 pb-0"
        >
          <v-icon v-show="designation" small color="#2a206a"
            >mdi-card-account-details</v-icon
          >
          <b class="pl-2"> {{ designation }} </b>
        </span>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import profileImage from "@/components/Includes/ProfileImage";
export default {
  data() {
    return {
      dummy_name: "dummy name",
    };
  },

  props: ["image", "name", "email", "designation", "role", "department"],
  components: {
    profileImage,
  },
};
</script>

<style scoped>
.display-style {
  font-size: 12px;
  color: #8993a4;
}
</style>
